module.exports = __webpack_public_path__ + "static/media/16UNODC15.72e11c4a.jpg";